import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaymentsStore {
  setAmount(amount: any) {
    localStorage.setItem('amount', amount);
  }

  getAmount() {
    return localStorage.getItem('amount');
  }

  removeAmount() {
    localStorage.removeItem('amount');
  }

  setPaymentMethod(method: string) {
    localStorage.setItem('paymentMethod', method);
  }

  getPaymentMethod() {
    return localStorage.getItem('paymentMethod');
  }

  setBankTransferDetails(bankTransferDetails: any) {
    localStorage.setItem('bankTransferDetails', JSON.stringify(bankTransferDetails));
  }

  getBankTransferDetails() {
    return JSON.parse(localStorage.getItem('bankTransferDetails'));
  }

  setUssdDetails(ussdDetails: any) {
    localStorage.setItem('ussdDetails', JSON.stringify(ussdDetails));
  }

  getUssdDetails() {
    return JSON.parse(localStorage.getItem('ussdDetails'));
  }

  setBankTransferResponse(bankTransferResponse: any) {
    localStorage.setItem('bankTransferResponse', JSON.stringify(bankTransferResponse));
  }

  getBankTransferResponse() {
    return JSON.parse(localStorage.getItem('bankTransferResponse'));
  }

  setUssdResponse(ussdResponse: any) {
    localStorage.setItem('ussdResponse', JSON.stringify(ussdResponse));
  }

  getUssdResponse() {
    return JSON.parse(localStorage.getItem('ussdResponse'));
  }

  removePaymentItems() {
    localStorage.removeItem('bankTransferDetails');
    localStorage.removeItem('ussdDetails');
    localStorage.removeItem('bankTransferResponse');
    localStorage.removeItem('ussdResponse');
  }
}
